import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { routes as baseAppRoutes } from "./baseApp/routes";
import { routes as smartBuildingsRoutes } from "./smartBuildings/routes";
import { connect } from 'react-redux';
import { forceCheck } from 'react-lazyload';

const App = () => {
    return (
        <div id="app-container" className="container-fluid no-max-height fill" onScroll={() => forceCheck()}>
            <main id="app-page-wrap" className="no-max-height fill">
                <Router>
                    <Switch>
                        {smartBuildingsRoutes}
                        {baseAppRoutes}
                    </Switch>
                </Router>
            </main>
        </div>
    );
};

const mapStateToProps = ({ authReducer }) => ({
    userLoggedIn: authReducer.userLoggedIn,
    user: authReducer.user
});

export default connect(
    mapStateToProps
)(App);
